module.exports = __webpack_public_path__ + "img/277516b367ec4ae8b2db289e77b46bbe.db177e03.png";